module.exports = __webpack_public_path__ + "img/qilin-stage5-blink.6360bc3d.png";